import { settings } from "../settings/settings";
import { getAppType } from "../getAppType";
import { AppType } from "../constants/AppType";

export function getStartPage() {
  if (getAppType() === AppType.iframe) {
    return settings.get().iframe_startPage;
  }

  return "/frontpage";
}
